// extracted by mini-css-extract-plugin
export default {"clickableRow":"ClanPlayer_clickableRow__S5TRF"};